import { brandingUrl } from '@pokerroom/branding/browser';
import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

interface BrandingItem {
  id: string;
  key: string;
  filePath: string;
  originalName: string;
  mimeType: string;
  updatedAt: string;
}

export function useBranding() {
  const { data: items = [] } = useQuery<BrandingItem[]>({
    queryKey: ['branding'],
    queryFn: () => api.get<BrandingItem[]>('/branding'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  const getBrandingUrl = (key: string): string | null => {
    const item = items.find((b) => b.key === key);
    if (!item) return null;
    return brandingUrl(key, item.updatedAt);
  };

  return { items, getBrandingUrl };
}

export function useBrandingByKey(key: string) {
  const { data: item } = useQuery<BrandingItem | null>({
    queryKey: ['branding', key],
    queryFn: () => api.get<BrandingItem | null>(`/branding/${key}`),
    staleTime: 5 * 60 * 1000,
  });

  const url = brandingUrl(key, item?.updatedAt);
  return { item, url };
}
